import React from 'react'
import "./Home.css"
import Body from "../../general/body/Body"
import Footer from "../../general/footer/Footer"

const Home = () => {
    return (
        <div>
            <Body />
            <Footer />
        </div>
    )
}

export default Home